import React from "react";

const Brazilian = () => {
  return (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 20 15"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        height="15"
        id="mask0_305_22301"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
        width="20"
        x="0"
        y="0"
      >
        <rect fill="white" height="15" width="20" />
      </mask>
      <g mask="url(#mask0_305_22301)">
        <path
          clipRule="evenodd"
          d="M0 0V15H20V0H0Z"
          fill="#009933"
          fillRule="evenodd"
        />
        <mask
          height="15"
          id="mask1_305_22301"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
          width="20"
          x="0"
          y="0"
        >
          <path
            clipRule="evenodd"
            d="M0 0V15H20V0H0Z"
            fill="white"
            fillRule="evenodd"
          />
        </mask>
        <g mask="url(#mask1_305_22301)">
          <g filter="url(#filter0_d_305_22301)">
            <path
              clipRule="evenodd"
              d="M9.95424 2.31503L17.5804 7.62969L9.8505 12.607L2.38058 7.52667L9.95424 2.31503Z"
              fill="#FFD221"
              fillRule="evenodd"
            />
            <path
              clipRule="evenodd"
              d="M9.95424 2.31503L17.5804 7.62969L9.8505 12.607L2.38058 7.52667L9.95424 2.31503Z"
              fill="url(#paint0_linear_305_22301)"
              fillRule="evenodd"
            />
          </g>
          <path
            clipRule="evenodd"
            d="M10 10.75C11.7259 10.75 13.125 9.35089 13.125 7.625C13.125 5.89911 11.7259 4.5 10 4.5C8.27411 4.5 6.875 5.89911 6.875 7.625C6.875 9.35089 8.27411 10.75 10 10.75Z"
            fill="#2E42A5"
            fillRule="evenodd"
          />
          <mask
            height="7"
            id="mask2_305_22301"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "alpha" }}
            width="8"
            x="6"
            y="4"
          >
            <path
              clipRule="evenodd"
              d="M10 10.75C11.7259 10.75 13.125 9.35089 13.125 7.625C13.125 5.89911 11.7259 4.5 10 4.5C8.27411 4.5 6.875 5.89911 6.875 7.625C6.875 9.35089 8.27411 10.75 10 10.75Z"
              fill="white"
              fillRule="evenodd"
            />
          </mask>
          <g mask="url(#mask2_305_22301)">
            <path
              clipRule="evenodd"
              d="M8.9875 9.10625L8.8479 9.17964L8.87456 9.0242L8.76162 8.91411L8.9177 8.89143L8.9875 8.75L9.0573 8.89143L9.21338 8.91411L9.10044 9.0242L9.1271 9.17964L8.9875 9.10625Z"
              fill="#F7FCFF"
              fillRule="evenodd"
            />
            <path
              clipRule="evenodd"
              d="M10.2375 9.10625L10.0979 9.17964L10.1246 9.0242L10.0116 8.91411L10.1677 8.89143L10.2375 8.75L10.3073 8.89143L10.4634 8.91411L10.3504 9.0242L10.3771 9.17964L10.2375 9.10625Z"
              fill="#F7FCFF"
              fillRule="evenodd"
            />
            <path
              clipRule="evenodd"
              d="M10.2375 9.85625L10.0979 9.92964L10.1246 9.7742L10.0116 9.66411L10.1677 9.64143L10.2375 9.5L10.3073 9.64143L10.4634 9.66411L10.3504 9.7742L10.3771 9.92964L10.2375 9.85625Z"
              fill="#F7FCFF"
              fillRule="evenodd"
            />
            <path
              clipRule="evenodd"
              d="M9.6125 7.23125L9.4729 7.30464L9.49956 7.1492L9.38662 7.03911L9.5427 7.01643L9.6125 6.875L9.6823 7.01643L9.83838 7.03911L9.72544 7.1492L9.7521 7.30464L9.6125 7.23125Z"
              fill="#F7FCFF"
              fillRule="evenodd"
            />
            <path
              clipRule="evenodd"
              d="M9.6125 8.48125L9.4729 8.55464L9.49956 8.3992L9.38662 8.28911L9.5427 8.26643L9.6125 8.125L9.6823 8.26643L9.83838 8.28911L9.72544 8.3992L9.7521 8.55464L9.6125 8.48125Z"
              fill="#F7FCFF"
              fillRule="evenodd"
            />
            <path
              clipRule="evenodd"
              d="M8.7375 7.85625L8.5979 7.92964L8.62456 7.7742L8.51162 7.66411L8.6677 7.64143L8.7375 7.5L8.8073 7.64143L8.96338 7.66411L8.85044 7.7742L8.8771 7.92964L8.7375 7.85625Z"
              fill="#F7FCFF"
              fillRule="evenodd"
            />
            <path
              clipRule="evenodd"
              d="M7.86247 8.35625L7.72287 8.42964L7.74953 8.2742L7.63659 8.16411L7.79267 8.14143L7.86247 8L7.93227 8.14143L8.08835 8.16411L7.97541 8.2742L8.00207 8.42964L7.86247 8.35625Z"
              fill="#F7FCFF"
              fillRule="evenodd"
            />
            <path
              clipRule="evenodd"
              d="M10.7375 6.23125L10.5979 6.30464L10.6246 6.1492L10.5117 6.03911L10.6677 6.01643L10.7375 5.875L10.8073 6.01643L10.9634 6.03911L10.8505 6.1492L10.8771 6.30464L10.7375 6.23125Z"
              fill="#F7FCFF"
              fillRule="evenodd"
            />
            <path
              d="M6.203 6.87317L6.29699 5.62671C9.2957 5.85283 11.6625 6.83881 13.3676 8.5927L12.4714 9.46403C10.9935 7.94389 8.91399 7.07759 6.203 6.87317Z"
              fill="#F7FCFF"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="10.292"
          id="filter0_d_305_22301"
          width="15.1998"
          x="2.38058"
          y="2.31506"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0313726 0 0 0 0 0.368627 0 0 0 0 0 0 0 0 0.28 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            mode="normal"
            result="effect1_dropShadow_305_22301"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_305_22301"
            mode="normal"
            result="shape"
          />
        </filter>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_305_22301"
          x1="20"
          x2="20"
          y1="15"
          y2="0"
        >
          <stop stopColor="#FFC600" />
          <stop offset="1" stopColor="#FFDE42" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Brazilian;
